import type { CatalogueSku } from '../../../services/rewards/types';

export interface AffordabilityState {
  affordableItem: CatalogueSku | null;
  dismissed: boolean;
  visible: boolean;
}

type Listener = (state: AffordabilityState) => void;

export class AffordabilityManager {
  private state: AffordabilityState = {
    affordableItem: null,
    dismissed: false,
    visible: false,
  };
  private listeners: Listener[] = [];

  getState(): AffordabilityState {
    return this.state;
  }

  subscribe(listener: Listener): () => void {
    this.listeners.push(listener);
    return () => {
      const idx = this.listeners.indexOf(listener);
      if (idx > -1) this.listeners.splice(idx, 1);
    };
  }

  check(balance: number, catalogue: CatalogueSku[]): void {
    // Skip comingSoon and out-of-stock items for affordability
    const eligible = catalogue.find((item) => !item.comingSoon && item.inStock);
    const hero = eligible ?? null;
    const canAfford = hero != null && balance >= hero.pointCost;

    const affordableItem = canAfford ? hero : null;
    // Show whenever user can afford something, unless dismissed this session
    const visible = canAfford && !this.state.dismissed;

    if (affordableItem === this.state.affordableItem && visible === this.state.visible) return;
    this.patch({ affordableItem, visible });
  }

  dismiss(): void {
    this.patch({ dismissed: true, visible: false });
  }

  destroy(): void {
    this.listeners = [];
  }

  private patch(partial: Partial<AffordabilityState>): void {
    this.state = { ...this.state, ...partial };
    this.emit();
  }

  private emit(): void {
    const snapshot = this.state;
    this.listeners.forEach((fn) => fn(snapshot));
  }
}
